export const isHandledOverpaid = ticket => {
  const handled = ticket && ticket.handled
  if (handled == null || handled === '') {
    return false
  }
  return handled === true || Number(handled) > 0
}

export const isUnhandledOverpaid = ticket => !isHandledOverpaid(ticket)

export const overpaidRowKey = ticket =>
  ticket.ticket_id != null ? ticket.ticket_id : ticket.order_product_id

export const unhandledOverpaidCount = tickets => {
  if (!Array.isArray(tickets)) {
    return 0
  }

  const ids = new Set()
  tickets.forEach(ticket => {
    if (!isUnhandledOverpaid(ticket)) {
      return
    }
    const key = overpaidRowKey(ticket)
    if (key != null) {
      ids.add(key)
    }
  })
  return ids.size
}

export const summarizeOverpaid = tickets => {
  if (!Array.isArray(tickets)) {
    return { count: 0, amount: 0 }
  }

  const unique = new Map()
  tickets.filter(isUnhandledOverpaid).forEach(ticket => {
    const key = overpaidRowKey(ticket)
    if (key != null && !unique.has(key)) {
      unique.set(key, ticket)
    }
  })

  let amount = 0
  unique.forEach(ticket => {
    amount += Number(ticket.price) || 0
  })

  return { count: unique.size, amount }
}
